import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';

export default function pageWhoWeAreWithData(WrappedComponent, options = {}) {
  const HOC = class extends Component {
    constructor(props) {
      super(props);
      this.wrapped = graphql(gql `
              query pageWhoWeAreQuery {
                thisPageWhoWeAre: pageWhoWeAres(q:"fields.route=${props.match.path.slice(1)}"){
                  route
                  navigationName
                  introHeader
                  introBody
                  introBackground {
                    url
                  }
                  people {
                    image {
                      url
                    }
                    name
                    title
                    titleCubs
                    route
                  }
                  employees {
                    name
                    title
                    department
                  }
                  clientsHeader
                  clientsBody
                  clientImages {
                    url
                    title
                  }
                }
                footer: globalSites {
                  mainNavigation {
                    footerHeader
                    footerBody
                    footerLinks {
                      __typename
                      ... on PageFreeText {
                        title
                        route
                      }
                    }
                    buttonCTA
                    phoneNumber
                    copyrightHolder
                  }
                  contactUsPage {
                    route
                  }
                }
              }
          `, { name: 'pageWhoWeAreQuery' })(WrappedComponent);
    }

    render() {
      const Wrapped = this.wrapped;
      return <Wrapped {...this.props}/>;
    }
  };

  return HOC;
}